import { render, staticRenderFns } from "./MasterProposal.vue?vue&type=template&id=6feba2b4&scoped=true&"
import script from "./MasterProposal.vue?vue&type=script&lang=js&"
export * from "./MasterProposal.vue?vue&type=script&lang=js&"
import style0 from "./MasterProposal.vue?vue&type=style&index=0&id=6feba2b4&prod&lang=css&"
import style1 from "./MasterProposal.vue?vue&type=style&index=1&id=6feba2b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feba2b4",
  null
  
)

export default component.exports